import moment from 'moment';
export const hotelRoomTypesSearchListGet = (data) => {
    return data.data;
}

export const destinationListGet = (data) => {
    return data.data;
}
export const filterPanelListGet = (data) => {
    return data.data;
}
export const paymentPriceDistributionGet = (data) => {
    return data.data;
}
export const paymentCreatePost = (data) => {
    return data.data;
}
export const paymentCreatePatch = (data) => {
    return data.data;
}
export const uploadScreenshotPost = (data) => {
    return data.data;
}
export const creditPointGet = (data) => {
    return data.data;
}
export const subscribApiCallFn = (data) => {
    return data.data;
}
export const getPaymentDetailsGet = (data) => {
    return data.data;
}
export const paymentDetailsDeleteApi = (data) => {
    return data.data;
}
export const guestCreateApi = (data) => {
    return data.data;
}
export const emailCheckApiGet = (data) => {
    return data.data;
}
export const signupCustomerApi = (data) => {
    return data.data;
}
export const packageTourListGet = (data) => {
    return data.data;
}
export const uploadPersonDetailsFn = (data) => {
    return data.data;
}
export const updatePersonDetailsApi = (data) => {
    return data.data;
}

export const createDmcLeadApi = (data) => {
    return data.data;
}

export const createDmcNoteApi = (data) => {
    return data.data;
}

export const tourLocationListGet = (data) => {
    return data.data;
}

export const serachDataFormatingFn = (searchData) => {
    let data = {};
    let filter_hash = {};
    data['startDate'] = moment(searchData.start_date).format('YYYY-MM-DD');
    data['endDate'] = moment(searchData.end_date).format('YYYY-MM-DD');

    data['adult'] = searchData.adult;
    let agesArr = [];
    if (searchData.children_age && Array.isArray(searchData.children_age) && searchData.children_age.length > 0) {
        searchData.children_age.forEach((val) => {
            let agesObj = {};
            if (val.age && val.age.value) {
                agesObj["age"] = val.age.value;
                agesArr.push(agesObj);
            }
        });
    }
    data['childs'] = JSON.stringify(agesArr);
    // Build customer_search_hash according to API requirements
    const propertyTypeVal = searchData?.filterData?.property_type || searchData?.property_type;
    if (propertyTypeVal && (Array.isArray(propertyTypeVal) ? propertyTypeVal.length > 0 : propertyTypeVal !== '')) {
        // Format property_type as a string (single value) if it's an array
        if (Array.isArray(propertyTypeVal)) {
            // Use the first value when sending to API
            filter_hash['property_type'] = propertyTypeVal[0];
        } else {
            filter_hash['property_type'] = propertyTypeVal;
        }
    }

    // Set basic_room_rate_min always
    filter_hash['basic_room_rate_min'] = searchData?.filterData?.budget_min !== undefined ?
        searchData.filterData.budget_min : 0;

    // Include these filters only if they exist and match API requirements
    if (searchData?.filterData?.amenities && searchData.filterData.amenities.length > 0) {
        filter_hash['amenity_types'] = Array.isArray(searchData.filterData.amenities) ?
            searchData.filterData.amenities.join(',') :
            searchData.filterData.amenities;
    }

    if (searchData?.filterData?.meals && searchData.filterData.meals.length > 0) {
        filter_hash['meals'] = Array.isArray(searchData.filterData.meals) ?
            searchData.filterData.meals.join(',') :
            searchData.filterData.meals;
    }

    if (searchData?.filterData?.budget_max && searchData.filterData.budget_max !== "") {
        filter_hash['basic_room_rate'] = searchData.filterData.budget_max;
    }

    let propertyRating = []
    if (searchData?.filterData?.property_rating && searchData.filterData.property_rating.length > 0) {
        const updatedPropertyRating = searchData.filterData.property_rating.map(item => {
            const numericPart = item.match(/\d+/);
            return numericPart ? numericPart[0] + " " : item;
        });
        propertyRating = updatedPropertyRating;

        if (propertyRating.length > 0) {
            filter_hash['star_category'] = propertyRating.join(',');
        }
    }
    if (Object.keys(filter_hash)) {
        data["customer_search_hash"] = JSON.stringify(filter_hash)
    }
    return data;
}

export const hotelCountByCountryGet = (data) => {
    return data.data;
};

export const hotelCountByTagGet = (data) => {
    return data.data;
};

export const hotelCountByCityGet = (data) => {
    return data.data;
};

export const hotelCountByStateGet = (data) => {
    return data.data;
};

export const destinationCityCountGet = (data) => {
    return data.data;
};

export const destinationStateCountGet = (data) => {
    return data.data;
};

export const tagCountGet = (data) => {
    return data.data;
};

export const destinationCountryCountGet = (data) => {
    return data.data;
};

export const getTourTagCountGet = (data) => {
    return data.data;
};

export const getTagWiseCountGet = (data) => {
    return data.data;
};


